
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("jgi3y", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.269fc037.js.map
